import { Link } from 'react-router-dom';
import React from 'react';
import { cn } from '../../lib/helperClass';

type Props = {
  text: string;
  className?: string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  onClick?: () => void;
  role?: 'link' | 'text';
  href?: string;
};

const TitleText = ({
  text,
  className,
  size = 'xl',
  onClick,
  role,
  href,
}: Props) => {
  const classes = cn(
    `text-light-text-primary dark:text-dark-text-primary text-${size} font-medium max-w-full break-words break-all whitespace-normal min-w-0`,
    className
  );

  if (role === 'link')
    return (
      <Link to={href || ''} className={classes}>
        {text}
      </Link>
    );

  return (
    <h3 onClick={onClick} className={classes}>
      {text}
    </h3>
  );
};

export default TitleText;
